import { GROOVEY_BLUEY, WAVY_NAVY } from 'Modules/Shared/constants/colors';

const primary = {
  main: WAVY_NAVY,
  light: GROOVEY_BLUEY,
};

export default primary;
